import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTakeoverUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#999" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 27.89a5.2 5.2 0 100-10.39 5.2 5.2 0 000 10.39zm0 1.08c-2.17 0-3.37.3-4.2.6-2.07.72-4.3 2.21-4.3 5.5 0 .82.6 1.44 1.63 1.78 1.27.42 4.48.52 6.87.52 2.39 0 5.6-.1 6.87-.52 1.03-.34 1.63-.96 1.63-1.79 0-3.28-2.23-4.77-4.3-5.5a12.1 12.1 0 00-4.2-.59z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42 27.89a5.2 5.2 0 100-10.39 5.2 5.2 0 000 10.39zm0 1.08c-2.17 0-3.37.3-4.2.6-2.07.72-4.3 2.21-4.3 5.5 0 .82.6 1.44 1.63 1.78 1.27.42 4.48.52 6.87.52 2.39 0 5.6-.1 6.87-.52 1.03-.34 1.63-.96 1.63-1.79 0-3.28-2.23-4.77-4.3-5.5a12.1 12.1 0 00-4.2-.59z"
        fill="#CCC"
      />
      <path
        d="M31 24.7l3 3-3 3m-5-6l3 3-3 3"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

SvgPicCircleTakeoverUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTakeoverUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTakeoverUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
